import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { AiSparklesSmallGrey } from '@vy/ui-design-system';
import { useContext } from 'react';
import { AiCopilotContext } from './context/AiCopilotProvider';

export const AiCopilotButton: React.FC = () => {
  const context = useContext(AiCopilotContext);

  if (!context) {
    return null;
  }

  return (
    <ButtonBase
      data-vy="ai-copilot-button"
      onClick={context.isOpen ? context.closeDrawer : context.openDrawer}
      sx={{
        background: 'linear-gradient(90deg, #dbebff 0%, #eefaf7 58.76%)',
        borderRadius: '100px',
        px: '12px',
        py: '8px',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <Box sx={{ width: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <AiSparklesSmallGrey />
        </Box>
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '16px',
            color: '#01060d',
            whiteSpace: 'nowrap',
          }}
        >
          Ask Agent
        </Typography>
      </Box>
    </ButtonBase>
  );
};
